import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";
import Modal from "react-responsive-modal";
import autoBind from "react-autobind";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";

import { getUrlForValue } from "../../actions/drive";
import { getSelectedActivityId } from "../../actions/playerActions";

class ImagePreview extends PureComponent {
	constructor(props) {
		super(props);
		autoBind(this);

		this.state = { paused: false };
	}

	onClickShare() {

	}

	onClickClose(e) {
		e.stopPropagation();

		this.setState({ paused: true });
		if (this.props.onClickClose) {
			this.props.onClickClose();
		}
	}

	// Doing at runtime...could potentially do first time loads up in state
	render() {
		const url = getUrlForValue(this.props.imageUri, getSelectedActivityId());

		let modal = null;

		if (this.props.imageUri !== null && this.props.imageUri !== "undefined" && this.props.imageUri !== "") {
			modal =
				<Modal classNames={{
					overlay: "ambifi-web-player",
					modal: "media-preview-modal",
					transitionEnter: "ambifi-web-player-modal-slide-up-enter",
					transitionEnterActive: "ambifi-web-player-modal-slide-up-enter-active",
					transitionExit: "ambifi-web-player-modal-slide-up-exit",
					transitionExitActive: "ambifi-web-player-modal-slide-up-exit-active"
				}}
					open={this.props.isOpen}
					showCloseIcon={false}
					onEntered={this.onModalEntered}
					onClose={() => { }}>
					<div style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%" }} onClick={(e)=>this.onClickClose(e)}>
						<div style={{ flex: "1 0 0", minHeight: 0, display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
							<img style={{ objectFit: "contain", width:"100%", maxHeight: "100%", maxWidth: "100%" }} alt="Preview" src={url} />
						</div>
						<div style={{ display: "flex", flexDirection: "row", padding: "12px", justifyContent: "flex-start" }}>
							{/*
							<div style={{ cursor: "pointer" }} onClick={this.onClickShare}>
								<FontAwesomeIcon style={{ color: "lightgreen", opacity: 1, fontSize: "32px" }} icon="share-alt" />
							</div>
							*/}
							<div style={{ cursor: "pointer" }} onClick={(e)=>this.onClickClose(e)}>
								<FontAwesomeIcon style={{ color: "red", opacity: 1, fontSize: "32px" }} icon='times' />
							</div>
						</div>
					</div>
				</Modal>;
		}
		return modal;
	}
}

ImagePreview.defaultProps = {
	paused: true,
	repeat: false,
	volume: 1,
	muted: true
};

export default branch({
}, ImagePreview);